import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Network } from 'lucide-react';

interface WorkflowVisualizerButtonProps {
  orderType?: string;
  className?: string;
}

export const WorkflowVisualizerButton: React.FC<WorkflowVisualizerButtonProps> = ({
  orderType,
  className = '',
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    // Navigate to workflow visualizer
    // If orderType is provided, we could filter by that type in the future
    navigate('/workflows');
  };

  return (
    <button
      onClick={handleClick}
      className={`flex items-center gap-2 px-3 py-2 rounded-lg border border-gray-300 bg-white hover:bg-gray-100 transition-colors ${className}`}
      title="View workflow visualization"
    >
      <Network className="h-4 w-4 text-gray-600" />
      <span className="hidden lg:block text-sm text-gray-700">
        Workflow
      </span>
    </button>
  );
};
